import { DateFormatOptions, ValidDate } from '@ngneat/transloco-locale';

export interface DateParams {
  date: ValidDate;
  options?: DateFormatOptions;
}
